export default __webpack_public_path__ + "static/media/athens.a72ce721.png";